import { Component, OnInit, inject } from '@angular/core';
import {DataService} from "../../services/data.service";
import {RouterLink} from "@angular/router";
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-position-list',
    imports: [RouterLink, NgIf],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-location-dot me-2"></i>Lagen <small class="text-muted">({{totalEntries}})</small></h3>
                </div>

                <button type="button" class="btn btn-primary mb-3" [routerLink]="['/position', 0]">Lage anlegen</button>

                <div class="table-responsive">
                    <table *ngIf="entries?.length > 0" class="table table-striped table-hover mb-0 pointer">
                        <thead>
                        <tr>
                            <th (click)="setOrder('name')">
                                Name <i class="fa-solid" *ngIf="predicate == 'name'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                            <th (click)="setOrder('stores')" style="width: 200px">
                                # Stores <i class="fa-solid" *ngIf="predicate == 'stores'" [class.fa-arrow-up]="!reverse" [class.fa-arrow-down]="reverse"></i>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        @for (entry of entries; track entry.id) {
                            <tr [routerLink]="['/position', entry.id]">
                                <td>{{ entry.name }}</td>
                                <td>{{ entry.stores }}</td>
                            </tr>
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    `
})
export class PositionListComponent implements OnInit {

    private dataService = inject(DataService);

    paginConfig: any = {
        itemsPerPage: 25,
        page: 1
    };
    entries!: any[]|null;
    totalEntries = 0;
    predicate = 'name';
    search: any = {
        text: ''
    };
    reverse = false;

    ngOnInit(): void {
        this.listEntries(this.paginConfig);
    }

    setOrder(order: any): void {
        this.predicate = order;
        this.reverse = !this.reverse;
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    checkFilterAndList(): void {
        this.paginConfig.page = 1;
        this.listEntries(this.paginConfig);
    }

    listEntries(event: any): void {
        this.paginConfig = event;

        this.entries = null;
        this.dataService.request('Position/listAll', {
            page: this.paginConfig.page,
            limit: this.paginConfig.itemsPerPage,
            order: this.predicate,
            reverse: this.reverse,
            filter: this.search.text,
        }).subscribe(response => {
            this.totalEntries = response.total;
            this.entries = response.positions;
        });
    }

}
